import { z } from 'zod';

export const PageableParamsSchema = z.object({
  page: z.number().optional(),
  size: z.number().optional(),
  sort: z.array(z.string()).optional(),
});

// =========================
// Response Dto & Schema
// =========================
export const createApiResponseSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
  z.object({
    data: dataSchema,
    meta: z.object({
      result: z.enum(['FAIL', 'SUCCESS']),
      errorCode: z.string().nullable(),
      message: z.string().nullable(),
    }),
  });

export const createPagingApiResponseSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
  z.object({
    resultList: z.array(dataSchema),
    totalElements: z.number(),
  });
